import React, { useEffect, useState } from "react";
import { headers as headersReq } from "sources/home";

export default function HomeHeaders() {
    const [headers, setHeaders] = useState("");
    useEffect(() => {
        headersReq().then((res) => {
            if (res) {
                setHeaders(res);
            }
        });
    }, []);

    return <div className="log-modal__text overflow-auto">{JSON.stringify(headers, null, 4)}</div>;
}
